export const linkButtonTheme = {
    name: 'LinkButton theme',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        appearance: {
            name: 'Appearance',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: ['Creative', 'Light', 'Muted', 'Neutral', 'Primary', 'Secondary']
                }
            ]
        },
        style: {
            name: 'Style',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Outline'] }]
        },
        prominence: {
            name: 'Prominence',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Elevated', 'Reduced'] }]
        },
        spacing: {
            name: 'Spacing',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: [
                        'Left',
                        'Right',
                        'LeftRight',
                        'LeftBottom',
                        'RightBottom',
                        'LeftRightBottom'
                    ]
                }
            ]
        },
        decorator: {
            name: 'Decorator',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Arrow'] }]
        },
        isBlock: {
            name: 'Is Block',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=linkButtonTheme.js.map